import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/resource/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/resource/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/resource/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/resource/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/resource/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/resource/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/resource/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/resource/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/resource/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/resource/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/resource/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/resource/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function createResourceDirect(resource, options){
  const config = {
    method: 'POST',
    data: resource,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v1/resources/direct', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.RESOURCE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function loadResources(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/resources', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.RESOURCE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function getResource(id, options, dispatch){
  dispatch(fetchRequest())

  const promise = api(`/v1/resources/${id}`, options)
    .then(({ data }) => {
      const normalizedJson = normalize(data, Schemas.RESOURCE)
      dispatch(updateEntities(normalizedJson))
      dispatch(fetchSuccess())

      return { success: true, result: data }
    })
    .catch((data) => {
      const errors = handleError(data)
      dispatch(deleteFailure(errors))

      return { success: false, result: errors }
    })
  return promise
}

export function loadResource(id, options){
  return (dispatch) => {
    dispatch(fetchRequest())

    return getResource(id, options, dispatch)
  }
}

export function updateResource(resource, options = {}){
  const config = {
    method: 'PUT',
    data: resource,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/resources/${resource.id}`, options, config)
      .then(() => {
        dispatch(updateSuccess())

        return getResource(resource.id, { includes: 'file' }, dispatch)
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function deleteResource(data){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v1/resources/${data.id}`, {}, config)
      .then(() => {
        const normalizedJson = normalize(data, Schemas.RESOURCE)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: data }
      })
      .catch((error) => {
        const errors = handleError(error)
        dispatch(deleteFailure(errors))

        return { success: false, result: errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
